import SectionHeader from "../components/ui/SectionHeader";
import { realizations } from "../data/siteData";

function RealizationsPage() {
  return (
    <section className="page-section">
      <div className="shell">
        <SectionHeader kicker="Realizace" title="Ukazky dokoncene prace">
          Fotky maji ukazat vysledek prace. Proto je nechavam jednoduse a bez tezkych efektu.
        </SectionHeader>

        <div className="mt-10 grid gap-6 md:grid-cols-3">
          {realizations.map((item) => (
            <article key={item.title} className="card overflow-hidden">
              <img src={item.image} alt={item.title} className="h-64 w-full object-cover" />
              <div className="p-5">
                <h2 className="text-lg font-bold text-white">{item.title}</h2>
                <p className="mt-1 text-sm text-slate-400">{item.place}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default RealizationsPage;
